import { createMutableAction, IBaseMutableAction } from '@bimser/core';
import * as ActionTypes from '../actionTypes';
import { IFixingColumn } from '../entities';

export function changeFixing(
	payload: Array<IFixingColumn>
): IBaseMutableAction<Array<IFixingColumn>> {
	return createMutableAction(ActionTypes.CHANGE_FIXING, payload);
}
